// extracted by mini-css-extract-plugin
export default {"Spinner":"Spinner_Spinner__h4mdc","spin":"Spinner_spin__TWxyk","Wrapper":"Spinner_Wrapper__zAkKL","Fill":"Spinner_Fill__zjTgz"};